module.exports = __webpack_public_path__ + "media/images/round-robin-44f0d456207e69cf4e033e134615fa6e.svg";